import { ErrorMessage } from '../../shared/models';
import { AlertCommunicationInfo, FlightInformation } from '.';

export interface FlightItineraryInformation {
    isVisible: boolean;
    validationMessages: ErrorMessage[];
    alertCommunicationInfo: AlertCommunicationInfo;
    flights: FlightInformation[];
}
